<template>
  <div>
    <div class="main-title">充值卡历史记录</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="user.buttons.indexOf(1020) < 0"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索卡号或姓名"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.fin_type"
              @change="search(searchParams)"
              style="width:120px">
              <el-option label="全部收支" value="全部收支"></el-option>
              <el-option label="收入" value="收入"></el-option>
              <el-option label="支出" value="支出"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.oper_id"
              filterable
              placeholder="搜素操作员"
              style="width:120px"
              @change="search(searchParams)">
              <el-option label="全部操作员" :value="null"></el-option>
              <el-option 
                v-for="item in userList"
                :key="item.id"
                :value="item.id"
                :label="item.realname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        :row-class-name="tableRowClassName"
        style="width:100%">
        <el-table-column
          prop="card_no"
          label="卡号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="card_name"
          label="持卡人"
          width="80">
        </el-table-column>
        <el-table-column
          prop="fin_type"
          label="类型"
          width="80">
        </el-table-column>
        <el-table-column
          prop="oper_type"
          label="摘要"
          width="110">
        </el-table-column>
        <el-table-column
          label="打印"
          width="70">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.fin_id > 0 && scope.row.is_del === '0'" @click="print(scope.row)">打印</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="oper_money"
          label="金额"
          width="70">
        </el-table-column>
        <el-table-column
          prop="pay_money"
          label="实收/实付"
          width="90">
        </el-table-column>
        <el-table-column
          prop="free_money"
          label="赠送金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="free_rate"
          label="赠送率"
          width="70">
          <template slot-scope="scope">
            <template v-if="scope.row.oper_type == '充值'">{{ scope.row.free_rate }}%</template>
          </template>
        </el-table-column>
        <el-table-column
          prop="oper_time"
          label="操作时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="oper_name"
          label="操作人"
          width="70">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="60">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="60">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.fin_id > 0 && scope.row.is_del === '0'" @click="del(scope.row)" style="color:#f56c6c;" :disabled="user.buttons.indexOf(1023) < 0">退款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      billList: [],
      sqlcode: 'card_history',
      searchForm: {
        query: '',
        oper_id: null,
        daterange: [
          new Date(),
          new Date()
        ],
        fin_type: '全部收支'
      },
      sumProps: [
        'oper_money',
        'pay_money',
        'free_money'
      ],
      userList: []
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          query: this.searchForm.query,
          oper_id: this.searchForm.oper_id,
          fin_type: this.searchForm.fin_type,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  mounted () {
    this.fetchUserList()
  },
  methods: {
    tableRowClassName ({row, rowIndex}) {
      if (row.is_del === '1') {
        return 'row-red'
      } else {
        return ''
      }
    },
    fetchUserList () {
      this.$http.get('/dbapi/user_list?is_del=0').then(response => {
        if (response.data.success) {
          this.userList = response.data.list
        }
      })
    },
    filterFinType (value, row) {
      return row.fin_type === value
    },
    filterOperType (value, row) {
      return row.oper_type === value
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (this.sumProps.indexOf(column.property) >= 0) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'card_no') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    del (row) {
      this.$confirm(`确定要退款吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/del_card_history', {
          id: row.id
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    print (row) {
      window.open(this.$http.receiptBaseUrl + '/fin_print?token=' + localStorage.getItem('kaochang.token') + '&ids=' + row.fin_id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/card/History.vue